export enum VehicleType {
  PRIME_MOVER = 'PRIME_MOVER',
  TRUCK = 'TRUCK',
  TRAILER = 'TRAILER'
}
